import {
  Button,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Spinner,
  tokens
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface CancelDialogProps {
  open: boolean;
  processing: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const CancelDialog = ({
  open,
  processing,
  onConfirm,
  onClose
}: CancelDialogProps) => {
  const { t } = useTranslation("requestsPage");

  return (
    <Dialog open={open} onOpenChange={(_, data) => (data.open ? undefined : onClose())}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("cancelDialog.title")}</DialogTitle>
          <DialogContent>
            <p>{t("cancelDialog.message")}</p>
            <p
              style={{
                marginTop: "8px",
                color: tokens.colorNeutralForeground3,
                fontSize: tokens.fontSizeBase200
              }}
            >
              {t("cancelDialog.warning")}
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              onClick={onClose}
              disabled={processing}
            >
              {t("cancelDialog.buttons.back")}
            </Button>
            <Button
              appearance="primary"
              onClick={onConfirm}
              disabled={processing}
              style={{
                backgroundColor: tokens.colorPaletteRedBackground3,
                color: tokens.colorNeutralForegroundOnBrand
              }}
              icon={processing ? <Spinner size="tiny" /> : undefined}
            >
              {processing ? t("modal.buttons.processing") : t("cancelDialog.buttons.confirm")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
